// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createAssetTrackingModal__SiofQ {
  width: 720px;
  height: 550px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.modalBody__yIT69 {
  flex: 1;
  padding: 25px;
}

.twoFields__wyw3S {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
}

.gpsTrackerField__ycxAG {
  width: 75%;
  margin-top: 10px;
  position: relative;
}

.modalFooter__VcZ_P {
  margin-top: 15px;
  padding: 0 25px 25px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
}

.addIcon__sAnrx path {
  fill: var(--buttons-surface);
}

.addButtonContainer__eZAhd {
  position: absolute;
  top: 0;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/CreateEditAssetTrackingModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,OAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,UAAA;EACA,gBAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAzEF;;AA6EE;EACE,4BAAA;AA1EJ;;AA8EA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;AA3EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.createAssetTrackingModal {\n  width: 720px;\n  height: 550px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modalBody {\n  flex: 1;\n  padding: 25px;\n}\n\n.twoFields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 24px;\n}\n\n.gpsTrackerField {\n  width: 75%;\n  margin-top: 10px;\n  position: relative;\n}\n\n.modalFooter {\n  margin-top: 15px;\n  padding: 0 25px 25px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 25px;\n}\n\n.addIcon {\n  path {\n    fill: var(--buttons-surface);\n  }\n}\n\n.addButtonContainer {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createAssetTrackingModal": `createAssetTrackingModal__SiofQ`,
	"modalBody": `modalBody__yIT69`,
	"twoFields": `twoFields__wyw3S`,
	"gpsTrackerField": `gpsTrackerField__ycxAG`,
	"modalFooter": `modalFooter__VcZ_P`,
	"addIcon": `addIcon__sAnrx`,
	"addButtonContainer": `addButtonContainer__eZAhd`
};
module.exports = ___CSS_LOADER_EXPORT___;
